import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_ALERT = new HttpContextToken(() => false);
